import React, { useState } from 'react';
import './Settings.css';

export default function Settings() {
  const [settings, setSettings] = useState({
    email: 'john.doe@example.com',
    notifications: {
      email: true,
      push: true,
      jobAlerts: true,
      newsletter: false,
    },
    privacy: {
      profileVisibility: 'public',
      showEmail: false,
      showPhone: false,
    },
  });

  const handleNotificationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      notifications: {
        ...prev.notifications,
        [name]: checked,
      },
    }));
  };

  const handlePrivacyChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { name, value, type } = e.target;
    const checked = type === 'checkbox' ? (e.target as HTMLInputElement).checked : value;
    
    setSettings(prev => ({
      ...prev,
      privacy: {
        ...prev.privacy,
        [name]: type === 'checkbox' ? checked : value,
      },
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically save the settings via an API
    console.log('Settings updated:', settings);
  };

  return (
    <div className="settings-container">
      <div className="settings-header">
        <h1 className="settings-title">Settings</h1>
        <p className="settings-subtitle">
          Manage your account settings and preferences.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="settings-form">
        <div className="settings-section">
          <div className="section-header">
            <h3 className="section-title">Profile</h3>
            <p className="section-description">
              This information will be displayed publicly so be careful what you share.
            </p>
          </div>
          <div className="form-grid">
            <div className="form-group col-span-4">
              <label htmlFor="email" className="form-label">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={settings.email}
                onChange={(e) => setSettings({...settings, email: e.target.value})}
                className="form-input"
              />
            </div>

            <div className="form-group col-span-6">
              <label htmlFor="photo" className="form-label">
                Photo
              </label>
              <div className="photo-upload">
                <div className="photo-placeholder">
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <button
                  type="button"
                  className="upload-button"
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <div className="section-header">
            <h3 className="section-title">Notifications</h3>
            <p className="section-description">
              We'll always let you know about important changes, but you pick what else you want to hear about.
            </p>
          </div>
          <div className="mt-6">
            <fieldset>
              <div className="notifications-list">
                {Object.entries(settings.notifications).map(([key, value]) => (
                  <div key={key} className="notification-item">
                    <div className="flex items-center h-5 notification-checkbox">
                      <input
                        id={key}
                        name={key}
                        type="checkbox"
                        checked={value as boolean}
                        onChange={handleNotificationChange}
                        className="checkbox-input"
                      />
                    </div>
                    <div className="notification-label">
                      <label htmlFor={key} className="notification-title">
                        {key
                          .replace(/([A-Z])/g, ' $1')
                          .replace(/^./, str => str.toUpperCase())}
                      </label>
                      <p className="notification-description">Get notified when {key} events occur.</p>
                    </div>
                  </div>
                ))}
              </div>
            </fieldset>
          </div>
        </div>

        <div className="settings-section">
          <div className="section-header">
            <h3 className="section-title">Privacy</h3>
            <p className="section-description">
              Control your privacy settings.
            </p>
          </div>
          <div className="mt-6 space-y-6">
            <div>
              <label htmlFor="profileVisibility" className="form-label">
                Profile Visibility
              </label>
              <select
                id="profileVisibility"
                name="profileVisibility"
                value={settings.privacy.profileVisibility}
                onChange={handlePrivacyChange}
                className="form-select"
              >
                <option value="public">Public</option>
                <option value="connections">Connections Only</option>
                <option value="private">Private</option>
              </select>
            </div>

            <div className="checkbox-container">
              <input
                id="showEmail"
                name="showEmail"
                type="checkbox"
                checked={settings.privacy.showEmail as boolean}
                onChange={handlePrivacyChange}
                className="checkbox-input"
              />
              <div className="checkbox-label">
                <label htmlFor="showEmail" className="checkbox-title">
                  Show email address on profile
                </label>
                <p className="checkbox-description">Your email will be visible to other users.</p>
              </div>
            </div>

            <div className="checkbox-container">
              <input
                id="showPhone"
                name="showPhone"
                type="checkbox"
                checked={settings.privacy.showPhone as boolean}
                onChange={handlePrivacyChange}
                className="checkbox-input"
              />
              <div className="checkbox-label">
                <label htmlFor="showPhone" className="checkbox-title">
                  Show phone number on profile
                </label>
                <p className="checkbox-description">Your phone number will be visible to other users.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
            <button
              type="button"
              className="upload-button"
              style={{ backgroundColor: 'white' }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-button"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
